import React, { useEffect, useState } from "react";
import { ShopUpsellModal } from "./ShopUpsellModal";
import { consumeShopUpsellPending } from "./shopBookingFlag";
import { isShopEnabled, openShop } from "./shop.utils";

/**
 * Drop-in host for Orders pages.
 * Shows the booking-success modal after a successful costume booking.
 * Shop CTA appears only when shopUrl is configured.
 */
export const ShopUpsellHost: React.FC = () => {
  const [show, setShow] = useState(false);
  const showShopCta = isShopEnabled();

  useEffect(() => {
    if (consumeShopUpsellPending()) {
      setShow(true);
    }
  }, []);

  return (
    <ShopUpsellModal
      show={show}
      showShopCta={showShopCta}
      onClose={() => setShow(false)}
      onContinueToShop={() => {
        openShop();
        setShow(false);
      }}
    />
  );
};
